import { render, staticRenderFns } from "./contentOndemandReport.vue?vue&type=template&id=236dfa8f&"
import script from "./contentOndemandReport.vue?vue&type=script&lang=js&"
export * from "./contentOndemandReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports